import * as Toasts from './Toast'

export default Toasts
